<template>
    <v-container grid-list-md>
        <v-layout justify-center>
            <v-flex xs12 md10 wrap>
                <v-toolbar color="secondary" dark> 
                    <v-toolbar-title>
                        Query ASN Owner for ASNs
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <info>
                        <template>
                            ASNs for a given owner
                        </template>
                        <template slot="body">
                            <p> Gives a list of ASNs completely <b> owned </b> by a given owner (from reference data)</p>
                            <br>
                            <p> Gives a list of ASNs <b> partially </b> owned by a given owner, along with a breakdown of the other owners (of prefixes owned by the given ASN)</p>
                        </template>
                    </info>
                </v-toolbar>
                <v-card>
                    <v-card-text>
                        <v-layout fluid justify-center>
                                        <v-flex xs1> <v-progress-circular color="purple" indeterminate v-if="searchLoading" /> </v-flex>
                            <v-flex xs10 md8>
                                <v-form ref="form" lazy-validation>
                                    <v-autocomplete 
                                        label="Organisation"
                                        v-model="org_select"
                                        :items="searchList"
                                        :search-input="search"
                                        :loading="searchLoading1"
                                        hide-no-data
                                        :disabled="!allowSearch"
                                        :rules="refRules"
                                        > </v-autocomplete>
                                </v-form>
                            </v-flex>

                            <v-flex xs1 md1>
                                <v-btn color="green" dark @click="executeQuery" :disabled="!allowSearch"> Submit </v-btn>
                                <v-progress-circular v-if="loadingData" indeterminate color="purple"> </v-progress-circular>
                            </v-flex>
                        </v-layout>
                        
                    </v-card-text>
                </v-card> 
            </v-flex>
        </v-layout>
        
        
        <v-layout justify-center>
            <v-flex xs12 md10 v-if="showMessage" pa-0 ma-0>
                <v-card color="red" pa-0 ma-0>
                    <v-card-text class="text-xs-center pa-0"> <h3> {{ resMessage }} </h3> </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <v-layout justify-center>
            <v-flex xs12 md6 v-if="showBreakdown">
                <v-toolbar color="secondary" dark>
                    <v-toolbar-title>
                        Ownership for AS {{ breakdownASN }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn @click="showBreakdown=!showBreakdown" color="red"> <v-icon> close </v-icon> </v-btn>
                </v-toolbar>
                <v-card>
                    <doughnut :chart-data="doughnutData" :options="doughnutoptions"> </doughnut>
                </v-card>
            </v-flex>
            <v-flex xs12 md6 v-if="showResults&!showBreakdown">
                <v-toolbar color="secondary" dark>
                    <v-toolbar-title>
                        Fully owned ASNs
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn v-if="listVSautocomplete" @click="listVSautocomplete=!listVSautocomplete" color="success"> SWITCH TO LIST </v-btn>
                    <v-btn v-if="!listVSautocomplete" @click="listVSautocomplete=!listVSautocomplete" color="success"> SWITCH TO SELECTOR </v-btn>
                    <info>
                        <template>
                            ASNs fully owned by {{ org_pick }}
                        </template>
                        <template slot="body">
                            <p> Can switch between either a list of all the ASNs fully owned by {{ org_pick }}, or a search bar which will autocomplete to find ASNs if there's one you'd like to check specifically</p>
                        </template>
                    </info>
                </v-toolbar>
                <v-card v-if="listVSautocomplete">
                    <v-layout justify-center>
                        <v-flex xs10>
                            <v-autocomplete
                            label="Start typing to find ASN"
                            v-model="asn_full_search"
                            :items="fullASNlist"
                            :search-input="search2"
                            :loading="searchLoading2"
                            hide-no-data></v-autocomplete>
                        </v-flex>
                    </v-layout>
                </v-card>
                <v-card v-if="!listVSautocomplete">
                    <v-layout justify-center>
                        <v-flex xs10>
                            <v-data-table :headers="oneHeader" :items="fullASNlist" :key="id"
                                :rows-per-page-items="rowsPerPageItems" :pagination.sync="pagination">
                                <template slot="items" slot-scope="props">
                                    <tr>
                                        <td class="text-xl-center"> {{ props.item }} </td>
                                    </tr>
                                </template>
                                <template slot="no-data">
                                    <v-alert :value="true" color="success" icon="warning">
                                    No fully owned ASNs
                                    </v-alert>
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-flex>
            <v-flex xs12 md6 v-if="showResults">
                <v-toolbar color="secondary" dark>
                    <v-toolbar-title>
                        Partially owned ASNs
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn v-if="listVSautocomplete2" @click="listVSautocomplete2=!listVSautocomplete2" color="success"> SWITCH TO LIST </v-btn>
                    <v-btn v-if="!listVSautocomplete2" @click="listVSautocomplete2=!listVSautocomplete2" color="success"> SWITCH TO SELECTOR </v-btn>
                    <info>
                        <template>
                            ASNs partially owned by {{ org_pick }}
                        </template>
                        <template slot="body">
                            <p> Can switch between either a list of all the ASNs partially owned by {{ org_pick }}, or a search bar which will autocomplete to find ASNs if there's one you'd like to check specifically</p>
                            <br />
                            <p> Click an entry in the table or press the breakdown button (on the selector) for an ownership breakdown to appear for the given ASN</p>
                        </template>
                    </info>
                </v-toolbar>
                <v-card v-if="listVSautocomplete2">
                    <v-layout justify-center>
                        <v-flex xs1></v-flex>
                        <v-flex xs6>
                            <v-autocomplete
                            label="Start typing to find ASN"
                            v-model="asn_part_search"
                            :items="partASNlist"
                            :search-input="search3"
                            :loading="searchLoading3"
                            cache-items
                            hide-no-data
                            @change="showBDstr=false"></v-autocomplete>
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-flex>
                            <v-btn @click="breakItDown" color="success"> BREAK IT DOWN </v-btn>
                        </v-flex>
                    </v-layout>
                    <v-card v-if="showBDstr">
                        <v-card-text class="text-xs-center">
                            <h4> {{ partBDstr }} </h4>
                        </v-card-text>
                    </v-card>
                </v-card>
                <v-card v-if="!listVSautocomplete2">
                    <v-layout justify-center>
                        <v-flex xs10>
                            <v-data-table :headers="threeHeader" :items="partASNs" :key="id"
                                :rows-per-page-items="rowsPerPageItems2" :pagination.sync="pagination2">
                                <template slot="items" slot-scope="props">
                                    <tr @click="clickHandler(props.item.asn, props.item.dict)">
                                        <td class="text-xl-center"> {{ props.item.asn }} </td>
                                        <td class="text-xl-center"> {{ props.item.ownership }} </td>
                                        <td class="text-xl-center"> {{ props.item.primary_owner }} </td>
                                    </tr>
                                </template>
                                <template slot="no-data">
                                    <v-alert :value="true" color="success" icon="warning">
                                    No partially owned ASNs
                                    </v-alert>
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-flex>

        </v-layout>
    </v-container>
</template>

<script>

import { API, graphqlOperation } from 'aws-amplify';
import info from '../../shared/operational/infopopout.vue';
import doughnut from '../../shared/developing/doughnut-graph.js'
import { findParentComponentByName } from '../utils/findParent.js'


export default {
    name: 'asn_owners',
    components: {
       info,
       doughnut
    },
    beforeMount () {
        let app = findParentComponentByName(this, 'app')
        app.checkSignedIn()
    },
    mounted () {
        this.runPreSearch();
    },
    methods: {
        runPreSearch: async function () {
            // returns list of owners beginning with...
            this.searchList = [];
            this.searchLoading = true;
            this.showMessage = false;
            if (this.search_type == "num123" || this.search_type == "chars!!!") {
                var query = `query getASNOwners {
                    getASNOwners ( search_string: "` + this.search_type + `")
                    {
                        organisation
                    }
                }`
                    
            } else {
                var query = `query getASNOwners {
                    getASNOwners ( search_string: "` + this.preSearch + `")
                    {
                        organisation
                    }
                }`

            }
            try {
                console.log(query);
                const results = await API.graphql(graphqlOperation(query));
                console.log(results);
                
                if (!results) {
                    var owners = false;
                } else {
                    var owners = results.data.getASNOwners;
                    if (owners) {
                        if (owners.length > 0) {
                            for (var i = 0 ; i < owners.length ; i ++ ) {
                                this.searchList.push(owners[i].organisation);
                            }
                        }
                        this.allowSearch = true;
                        this.searchLoading = false;
                    }
                    console.log(owners);
                }
            } catch(err) {
                console.log(err)
                this.resMessage = "Query Error";
                this.searchLoading = false;
                this.showMessage = true;
            }
            
        },
        executeQuery: async function () {
            if (this.$refs.form.validate()) {
                this.loadingData = true;
                this.showMessage = false;
                this.showBreakdown = false;
                this.showResults = false;
                this.org_pick = this.org_select
                this.partASNs = [];
                this.partASNlist = [];
                this.fullASNlist = [];
                
                try {
                    var query = `query getASNOwnersFromASNs { getASNOwnersFromASNs (
                        asnstr: "` + this.org_select + `")
                        {
                            asn
                            own_dict
                            primary_owner
                        }
                    }`
                    console.log(query)
                    const results = await API.graphql(graphqlOperation(query));
                    console.log(results);
                    if (results) {
                        var asnowns = results.data.getASNOwnersFromASNs;
                        if (asnowns) {
                            if (asnowns.length > 0) {
                                for (var i = 0 ; i < asnowns.length ; i ++ ) {
                                    //console.log(asnowns[i])
                                    var owndict = JSON.parse(asnowns[i].own_dict)
                                    //console.log(owndict)
                                    if (Object.keys(owndict).length > 1) {
                                        // Add to partially owned
                                        var sum = 0;
                                        for (var ownr in owndict) {
                                            if (owndict.hasOwnProperty(ownr)) {
                                                sum += parseFloat( owndict[ownr] )
                                            }
                                        }
                                        var newown_dict = {};
                                        var newown_str = "";
                                        var j = 1;
                                        for (var ownr in owndict) {
                                            if (owndict.hasOwnProperty(ownr)) {
                                                if (j == Object.keys(owndict).length) {
                                                    newown_str = newown_str + ownr + ": " + (owndict[ownr]*100/sum).toFixed(2) + "%";
                                                    var p = (owndict[ownr]*100/sum).toFixed(2);
                                                    newown_dict[ownr] = p;
                                                } else {
                                                    newown_str = newown_str + ownr + ": " + (owndict[ownr]*100/sum).toFixed(2) + "%, ";
                                                    var p = (owndict[ownr]*100/sum).toFixed(2);
                                                    newown_dict[ownr] = p;
                                                }
                                                
                                            }
                                            j += 1;
                                        }
                                        this.partASNs.push({
                                            "asn": asnowns[i].asn,
                                            "ownership": newown_str,
                                            "dict": newown_dict,
                                            "primary_owner": asnowns[i].primary_owner.replace(/\/\//g, " && ")
                                        })
                                        this.partASNlist.push(asnowns[i].asn)
                                    } else {
                                        // Add to fully owned
                                        this.fullASNlist.push(asnowns[i].asn)

                                    }                                    
                                }
                                //console.log(this.partASNs)
                                //console.log(this.fullASNlist)
                                this.showResults = true;
                                this.loadingData = false;
                            } else {
                                this.resMessage = "No ASNs owned by given organisation"
                                this.showMessage = true;
                                this.loadingData = false;
                            }
                        } else {
                            this.resMessage = "No ASNs owned by given organisation"
                            this.showMessage = true;
                            this.loadingData = false;
                        }
                    }

                } catch (err) {
                    console.log(err)
                    this.resMessage = "Backend connection error"
                    this.showMessage = true;
                    this.loadingData = false;
                }
            }
        },
        querySelections (v) {
            this.searchLoading1 = true
            // Simulated ajax query
            setTimeout(() => {
                this.items = this.searchList.filter(e => {
                return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
                })
                this.searchLoading1 = false
            }, 500)
        },
        createdoughnutDataCountry: function (countryBD) {
            var data = { datasets: [{ data: [], backgroundColor: []}], labels: [] };

            var countrykeys = Object.keys(countryBD);

            for (var i = 0; i < countrykeys.length; i=i+1){
                data.labels.push(countrykeys[i])
                data.datasets[0].data.push(countryBD[countrykeys[i]])
                var color = "hsla(" + ~~(360 * Math.random()) + "," +"50%,"+"50%,1)"
                data.datasets[0].backgroundColor.push(color)
            }
            return data
        },
        asnFullQuerySelections (v) {
            this.searchLoading2 = true
            // Simulated ajax query
            setTimeout(() => {
                this.items = this.fullASNlist.filter(e => {
                return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
                })
                this.searchLoading2 = false
            }, 500)
        },
        asnPartQuerySelections (v) {
            this.searchLoading3 = true
            // Simulated ajax query
            setTimeout(() => {
                this.items = this.partASNlist.filter(e => {
                return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
                })
                this.searchLoading3 = false
            }, 500)
        },
        breakItDown: async function () {
            var p_asn = this.asn_part_search;
            for(var i = 0; i < this.partASNs.length ; i++) {
                if(this.partASNs[i].asn == p_asn) {
                    this.doughnutData = false;
                    this.partBDstr = this.partASNs[i].ownership;
                    this.showBDstr = true;
                    var doughnutDataCountry = this.createdoughnutDataCountry(this.partASNs[i].dict);
                    this.breakdownASN = p_asn;
                    this.doughnutData = doughnutDataCountry;
                    this.showBreakdown = true;
                }
            }
        },
        clickHandler: async function (asn, dict) {
            this.doughnutData = false;
            var doughnutDataCountry = this.createdoughnutDataCountry(dict);
            this.breakdownASN = asn;
            this.doughnutData = doughnutDataCountry;
            this.showBreakdown = true;
        },
        flipSearch: async function () {
            this.allowSearch = !this.allowSearch;
            this.$refs.form.reset();
            this.org_select = "";
            this.searchList = [];
        },
    },
    watch: {
        search (val) {
            val && val != this.org_select && this.querySelections(val)
        },
        search2 (val) {
            val && val != this.asn_full_search && this.asnFullQuerySelections(val)
        },
        search3 (val) {
            val && val != this.asn_part_search && this.asnPartQuerySelections(val)
        }
    },
    data () {
        return {
            org_select: "",
            org_pick: "",
            search_type: "text",
            allowSearch: false,
            preSearch: "",
            searchList: [],
            preSearchRules: [ v => !!v || 'Please enter at least one character (a-zA-Z)', v => /^[a-zA-Z]+$/.test(v) || 'Must be (a-zA-Z) characters only'],
            refRules: [ v => !!v || 'Please enter an organisation'],
            threeHeader: [
                { text: 'ASN', value:'asn', align:'centre', sortable: false},
                { text: 'Ownership Breakdown', value:'ownership', align:'centre', sortable: false},
                { text: 'Majority Owner(s)', value:'primary_owner', align:'centre', sortable: false}
            ],
            oneHeader: [
                { text: 'ASN', value:'asn', align:'centre', sortable: false}
            ],
            breakdownASN: null,
            partBDstr: false,
            showBDstr: false,
            partASNs: [],
            partASNlist: [],
            fullASNlist: [],
            loadingData: false,
            searchLoading: false,
            searchLoading1: false,
            searchLoading2: false,
            searchLoading3: false,
            rowsPerPageItems: [50, 100],
            pagination: {
                rowsPerPage: 50
            },
            rowsPerPageItems2: [10, 20, 50, 100],
            pagination2: {
                rowsPerPage: 20
            },
            asn_full_search: "",
            asn_part_search: "",
            listVSautocomplete: true,
            listVSautocomplete2: true,
            showResults: false,
            showBreakdown: false,
            resMessage: "this is an error message",
            showMessage: false,
            doughnutData: null,
            doughnutoptions: {
                responsive: true,
                maintainAspectRatio: true,
            },
        }
    },
    

}
</script>

<style scoped>

    tbody tr:nth-of-type(even) {
      background-color: rgba(0, 0, 0, .05);
    }

    .v-table tr:hover:not(.v-table__expanded__content) {
        background-color: rgba(0, 0, 0, .4);
    }

</style>